module.exports = __webpack_public_path__ + "static/img/step3.219b834.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/guide/step3.png
// module id = m0HJ
// module chunks = 1